<div class="form-wrapper">

  <div class="premium-card">

    <!-- Header -->
    <div class="card-header">

      <div class="header-title-row">

        <button
          type="button"
          class="widowed-back-btn"
          (click)="goBack()"
          aria-label="Go back"
        >
          <span class="material-symbols-outlined">
            arrow_back
          </span>
        </button>

        <h3>Get Free Quotes</h3>

      </div>

      <p>
        Tell us what you need and our premium vendors will contact you.
      </p>

    </div>


    <!-- Form -->
    <div class="card-body">

      <form
        [formGroup]="leadForm"
        (ngSubmit)="onSubmit()"
      >

        <!-- Couple Name -->
        <div class="form-group">

          <label>
            Couple's Name
          </label>

          <input
            type="text"
            class="form-control"
            formControlName="coupleName"
            placeholder="e.g. Rahul & Priya"
          >

          <span
            *ngIf="leadForm.get('coupleName')?.invalid && leadForm.get('coupleName')?.touched"
            class="error-text"
          >
            Name is required
          </span>

        </div>


        <!-- Phone -->
        <div class="form-group">

          <label>
            Phone Number
          </label>

          <input
            type="text"
            class="form-control"
            formControlName="phone"
            placeholder="10-digit mobile number"
            maxlength="10"
            (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
          >

          <span
            *ngIf="leadForm.get('phone')?.invalid && leadForm.get('phone')?.touched"
            class="error-text"
          >
            Valid 10-digit phone number is required
          </span>

        </div>


        <!-- Event Date -->
        <div class="form-group">

          <label>
            Event Date
          </label>

          <input
            type="date"
            class="form-control"
            formControlName="eventDate"
          >

          <span
            *ngIf="leadForm.get('eventDate')?.invalid && leadForm.get('eventDate')?.touched"
            class="error-text"
          >
            Event date is required
          </span>

        </div>


        <!-- City -->
        <div class="form-group">

          <label>
            City
          </label>

          <ng-select
            class="custom-select"
            [items]="cities"
            formControlName="city"
            placeholder="Select a city"
          >
          </ng-select>

          <span
            *ngIf="leadForm.get('city')?.invalid && leadForm.get('city')?.touched"
            class="error-text"
          >
            City is required
          </span>

        </div>


        <!-- Services -->
        <div class="form-group">

          <label>
            Services Required
          </label>

          <ng-select
            class="custom-select"
            [items]="categories"
            [multiple]="true"
            formControlName="categoriesNeeded"
            placeholder="Select one or more services"
          >
          </ng-select>

          <span
            *ngIf="leadForm.get('categoriesNeeded')?.invalid && leadForm.get('categoriesNeeded')?.touched"
            class="error-text"
          >
            Please select at least one service
          </span>

        </div>


        <!-- Budget -->
        <div class="form-group">

          <label>
            Estimated Budget
          </label>

          <input
            type="text"
            class="form-control"
            formControlName="budget"
            placeholder="e.g. ₹1,00,000 - ₹5,00,000"
          >

        </div>


        <!-- Submit -->
        <button
          type="submit"
          class="btn-submit"
        >
          Submit Request
        </button>

      </form>

    </div>

  </div>

</div>